















import 'reflect-metadata'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { EVMBlockQueryResponse } from '@/store/modules/blocks/models'

@Component({
    components: {},
})
export default class LatestBlock extends Vue {
    date(timestamp: any) {
        return new Date(parseInt(timestamp)).toUTCString()
    }

    get block(): EVMBlockQueryResponse {
        return this.$root.$store.state.Blocks?.latestBlockDetail
    }

    get latestBlockNumber(): string {
        return this.$root.$store.state.Blocks?.latestBlockNumber
    }

    @Watch('latestBlockNumber')
    updateBlock() {
        this.$root.$store
            .dispatch('Blocks/getEVMBlock', {
                height: this.latestBlockNumber || '0',
            })
            .catch((e) => {
                console.log(e.message)
            })
    }
}
